// CategoryTabs.jsx
import React from 'react'

export default function CategoryTabs({
  categories = [],       // ← now comes in as a prop
  selected,              // ← which key is active
  onSelect,              // ← callback(key) when you click
}) {
  return (
    <div className="flex gap-2 px-2 bg-white">
      {categories.map(cat => {
        const isActive = cat.key === selected
        const Icon = cat.Icon || null

        return (
          <div key={cat.key} className="relative flex-1">
            <button
              onClick={() => onSelect(cat.key)}
              className={`
                w-full rounded-lg text-white font-medium leading-none min-h-[48px]
                ${isActive ? 'bg-pink' : 'bg-[#00A3DA]'}
                transition-colors duration-150
              `}
            >
              <span className="flex flex-col items-center justify-center gap-1">
                {Icon && <Icon width={20} height={20} />}
                <span>{cat.label}</span>
              </span>
            </button>
            {isActive && (
              <span
                className="
                  absolute left-1/2 -bottom-2 transform -translate-x-1/2
                  w-0 h-0 border-l-8 border-r-8 border-t-8
                  border-l-transparent border-r-transparent border-pink
                "
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
